module.exports = __webpack_public_path__ + "img/londonlogo.71da6224.jpg";